import PropTypes from 'prop-types';
import React from 'react';
import { Checkbox } from 'react-bootstrap';

const CheckboxAdapter = ({
  input,
  label,
  customClass,
  disabled,
  right,

  ...rest
}) => (
  <Checkbox
    {...input}
    title={label}
    disabled={disabled}
    className={`${right ? 'm-r-16' : ''}`}
    {...rest}
  >
    <span className={`checkmark ${right ? 'right' : ''}`}></span>
    <span className={`${disabled ? 'text-muted' : ''} ${customClass || ''}`}>
      {label}
    </span>
  </Checkbox>
);

CheckboxAdapter.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
};

export default CheckboxAdapter;
